import { render, staticRenderFns } from "./Dependientes.vue?vue&type=template&id=392483fe&scoped=true&lang=html&"
import script from "./Dependientes.vue?vue&type=script&lang=js&"
export * from "./Dependientes.vue?vue&type=script&lang=js&"
import style0 from "./Dependientes.vue?vue&type=style&index=0&id=392483fe&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392483fe",
  null
  
)

export default component.exports